import { jsx } from "react/jsx-runtime";
import { Button, cn } from "@pcln/horizon";
function SubmitButton({ children, className, isMobile, type = 'primary', emphasis, size = 'lg' }) {
    return /*#__PURE__*/ jsx(Button, {
        type: type,
        emphasis: emphasis,
        size: size,
        buttonType: "submit",
        className: cn(className, isMobile && 'fixed right-4 bottom-4 left-4'),
        children: children
    });
}
export { SubmitButton };
